import React from 'react';
import SmallCarousel from './SmallCarousel';
import { ThumbnailProductImage } from 'scy/ProductImage';
import styles from './styles.mod.scss';

export default function ThumbnailCarousel({
  products,
  onClick,
  sliderSettings
}) {
  return (
    <SmallCarousel {...sliderSettings}>
      {products.map(product => (
        <div key={product.sku_id} className={styles.productImageContainer}>
          <ThumbnailProductImage
            product={product}
            className={styles.productImage}
            onClick={onClick ? () => onClick(product) : null}
          />
        </div>
      ))}
    </SmallCarousel>
  );
}
